export default __webpack_public_path__ + "media/images/mailer/wordmark-92d0aa2bb764980aa5f9fa73aa7de177.png";